<template>
  <div>
    <div class="molecule-list-item-credential">
      <label class="molecule-list-item-credential__text w-90">
        <slot name="item"></slot>
      </label>

      <feather-icon
        v-if="!isDelete"
        class="icon-size-24px icon-danger"
        icon="Trash2Icon"
        @click="isDelete = true"
      />

      <div v-if="isDelete" class="molecule-list-item-credential__button">
        <atom-button
          buttonId="confirm-delete-snmp"
          :isOnlyIcon="true"
          iconLeft="CheckIcon"
          buttonColor="danger"
          class="molecule-list-item-credential__button--delete"
          @click="clickButtonDelete"
        ></atom-button>

        <atom-button
          buttonId="cancel-delete-snmp"
          :isOnlyIcon="true"
          iconLeft="XIcon"
          buttonStyle="border"
          buttonColor="secondary"
          class="molecule-list-item-credential__button--cancel"
          @click="isDelete = false"
        ></atom-button>
      </div>
    </div>

    <div class="molecule-list-item-credential__line"></div>
  </div>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
export default {
  name: "MoleculeListItemCredential",
  components: {
    AtomButton,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  emits: ["delete"],
  data() {
    return {
      isDelete: false,
    }
  },
  methods: {
    clickButtonDelete() {
      this.$emit("delete", this.id)
      this.isDelete = false
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule-list-item-credential {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.molecule-list-item-credential__text {
  font-weight: 600;
  font-size: 14px;
  color: #82868b;
  margin-bottom: 0;
  overflow-wrap: break-word;
}
.molecule-list-item-credential__button {
  display: flex;
  justify-content: end;
}
.molecule-list-item-credential__button--delete {
    height: 38px;
    margin-right: 10px;
}
.molecule-list-item-credential__button--cancel {
    height: 38px;
}
.molecule-list-item-credential__line {
  margin-top: 16px;
  margin-bottom: 16px;
  border: 1px solid #ebe9f1;
  width: 100%;
}
</style>
